<template>
    <header class="gHeader">
        <div class="gHeader__body">
            <div class="gLogo">
                <router-link :to="$store.state.appRootPath" aria-label="PRESTACT"></router-link>
            </div>
            <nav class="gNav" role="navigation">
                <b-nav v-if="$store.state.isAdmin">
                    <b-nav-item :to="{ name: 'calendar' }"><i class="fas fa-calendar-alt"></i> Calendrier</b-nav-item>
                    <b-nav-item :to="{ name: 'orderListAdmin' }"><i class="fas fa-file-alt"></i> Commandes</b-nav-item>
                    <b-nav-item :to="{ name: 'users' }"><i class="fas fa-address-card"></i> Utilisateurs</b-nav-item>
                    <b-nav-item :to="{ name: 'dynContents' }"><i class="fas fa-database"></i> Données modifiables</b-nav-item>
                    <b-nav-item :to="{ name: 'userHistory' }" v-if="$store.state.userRole == 'admin'"><i class="fas fa-history"></i> Historique utilisateur</b-nav-item>
                    <b-nav-item :to="{ name: 'statistic' }" v-if="$store.state.userRole == 'admin'"><i class="fas fa-chart-pie"></i> Statistique</b-nav-item>
                </b-nav>
                <b-nav v-else>
                    <b-nav-item :to="{ name: 'newOrder' }"><i class="fas fa-newspaper"></i> Nouvelle Commande</b-nav-item>
                    <b-nav-item :to="{ name: 'orderList' }"><i class="fas fa-file-alt"></i> Gestion Commande</b-nav-item>
                    <b-nav-item :to="{ name: 'faq' }"><i class="fas fa-question-circle"></i> FAQ</b-nav-item>
                </b-nav>
            </nav>
            <menu class="gToolBox">
                <ul class="gToolBox__actions">
                    <li><strong>{{ pageTitle }}</strong></li>
                    <li><a href="" @click="logout">Logout</a></li>
                </ul>
                <div class="gToolBox__greeting">
                    <p>Bonjour, 
                        <span class="userName">{{ $store.state.userRole }} {{ $store.state.UserLogin }}</span>
                    </p>
                    <div class="gToolBox__pic"><img src="../assets/user.jpg" alt="" class="u-responsiveImg"></div>
                </div>
            </menu>
        </div>
     
    </header>
       
</template>

<script>
export default {
    data() {
        return {
            pageTitle: null
        }
    },
    methods: {
        logout(e) {
            e.preventDefault();
            this.$AJAX.get('/UserSession/logout').then(() => {
            this.$store.dispatch('logout');
            return this.$router.push('/Login');
            });
        },
        getPageTitle() {
            if (this.$checkNull(this.$route.meta.title)) {
                let _title = this.$route.meta.title.split(' | ');
                this.pageTitle = _title[1];
            }
        }
    },
    watch: {
        '$route': {
            handler: 'getPageTitle',
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.gHeader {
    position: relative;
    background-color: $third-color;
    &__body {
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }
    &::before {
        content: '';
        width: 105%;
        height: $headerHeight;
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        box-shadow: 1px 1px 1px 0 $color-black-transparent;
        background-color: $third-color;
    }
}
.gLogo {
    height: 50px;
    position: relative;
    flex: 0 0 150px;
    overflow: hidden;
    a {
        width: 100%;
        height: 100%;
        position: relative;
        display: block;
        z-index: $z-lvl2;
        background: rgb(255, 255, 255);
        &::after {
            content: '';
            width: 100%;
            height: 60%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            margin: 0;
            margin: auto;
            display: block;
            background: url('../assets/logo.png') no-repeat center center / contain;
      }
    }
}
.gNav {
    flex: 1 1 calc(100% - 150px);
    height: $headerHeight;
    overflow: hidden;
    .nav-link {
        height: $headerHeight;
        position: relative;
        z-index: $z-lvl2;
        padding: 1rem;
        outline: 1px solid $third-color;
        color: $primary-color;
        letter-spacing: 2px;
        line-height: 2.2;
        font-size: 13px;
        font-family: Roboto, "Arial Narrow", Arial, sans-serif;
        background: rgb(255, 255, 255);
        &.active {
            color: $color-white;
            outline: 1px solid rgb(255, 255, 255);
            background-color: rgb(56, 124, 227);
        }
        &::before {
            content: '';
            width: 100%;
            height: 2px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            background: repeating-linear-gradient(90deg, $secondary-color 10px, $primary-color 11px);
            transition: transform .3s ease-out;
        }
        &:hover::before,
        &.active::before {
            transform: scaleY(6);
        }
        &.active::before {
            background: repeating-linear-gradient(90deg, rgb(255, 255, 255) 10px, $primary-color 11px);
        }
    }
    @include media-mobile() {
        .nav-link {
            display: none;
        }
    }
  }
  .gToolBox {
    flex: 0 0 26rem;
    min-width: 25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0 0 0 5px;
    background: $color-white;
    &__greeting {
        display: flex;
        align-items: center;
    }
    .userName {
        display: inline-block;
        margin-right: 15px;
    }
    p {
        margin-bottom: 0;
        text-align: center;
    }
    &__pic {
        width: $headerHeight;
    }
    &__actions {
        > li {
            display: block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/Header.vue